import type { ICognitoUser } from '@shared/types/cognito-user'

const getPathKey = ({ keyPrefix, username }: { keyPrefix: string; username: string }) => {
  return `${keyPrefix}.${username}.savedPath`
}

export const saveLogoutRoute = ({ user }: { user: ICognitoUser | null }) => {
  const fullPath = location.href.replace(location.origin, '')
  const username = user?.getUsername() || 'unknown'
  const keyPrefix = user?.keyPrefix || 'unknown'
  const pathKey = getPathKey({ keyPrefix, username })
  if (fullPath !== '/not-found') {
    localStorage.setItem(pathKey, fullPath)
  }
}

export const getSavedPath = ({ user }: { user: ICognitoUser | null }) => {
  const username = user?.getUsername() || 'unknown'
  const keyPrefix = user?.keyPrefix || 'unknown'
  const namedPathKey = getPathKey({ keyPrefix, username })
  const unknownPathKey = getPathKey({ keyPrefix: 'unknown', username: 'unknown' })
  const savedPath = localStorage.getItem(namedPathKey)
  const unknownPath = localStorage.getItem(unknownPathKey)
  return savedPath ? savedPath : unknownPath
}
